import * as React from 'react';
const SvgX = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>
        <path
            fill='currentColor'
            fillRule='evenodd'
            d='M7.373 3.604H2.894l5.31 6.956-4.97 5.835H5.53l3.76-4.413 3.338 4.373h4.478l-5.464-7.158.01.012 4.705-5.523H14.06l-3.494 4.102zM5.366 4.823H6.76l7.874 10.314H13.24z'
            clipRule='evenodd'
        />
    </svg>
);
export default SvgX;
